module.exports = __webpack_public_path__ + "static/intact.a668a1ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/examples/vampire-example/intact.png
// module id = 1015
// module chunks = 13396140415750